import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';

@Injectable()
export class NotificationCategoryService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/notification_categories`);
  }

  override update(model: any, urlParams?: any, apiParams?: any): Observable<any> {
    const url = this.baseUrl + '/update';
    return this.http.put<any>(url, model, {
      params: this.toHttpParams(apiParams || {})
    });
  }
}
